<h1 mat-dialog-title class="text-align-center">{{ title }}</h1>
<ng-container [ngSwitch]="serialsLoading$ | async">
	<div class="flex justify-center align-center" *ngSwitchCase="'loading'">
		<mat-spinner></mat-spinner>
	</div>
	<div class="flex justify-center align-center" *ngSwitchCase="'error'">
		<p>לא ניתן לטעון מקטים, נסו שנית מאוחר יותר</p>
	</div>
	<ng-container *ngSwitchCase="'success'" [ngSwitch]="taskSendLoading$ | async">
		<div class="flex justify-center align-center" *ngSwitchCase="'loading'">
			<mat-spinner></mat-spinner>
		</div>
		<ng-container *ngSwitchCase="'success'">
			<div class="flex justify-center align-center" mat-dialog-content>
				<h3 class="text-align-center valid-color">משימה {{ taskID$ | async }} נשלחה בהצלחה!</h3>
			</div>
			<div mat-dialog-actions>
				<button mat-raised-button color="primary" [mat-dialog-close]>סגור</button>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'error'">
			<div class="flex justify-center align-center" mat-dialog-content>
				<h3 class="text-align-center invalid-color">לא ניתן לשלוח משימה, נסו שנית</h3>
			</div>
			<div mat-dialog-actions>
				<button mat-raised-button color="primary" (click)="backFromTaskError()">חזור</button>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="'idle'">
			<div mat-dialog-content>
				<form [formGroup]="form" class="grid" dir="rtl">
					<!-- <mat-form-field>
						<mat-label>מקט / סריאלי</mat-label>
						<input type="text" matInput [matAutocomplete]="auto" formControlName="serialNumber" />
						<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFnSerials">
							<mat-option *ngFor="let sn of serialNumbers$ | async" [value]="sn" style="direction: rtl">
								<span style="unicode-bidi: isolate">{{ sn.ProductId }}</span> /
								<span style="unicode-bidi: isolate">{{ sn.SerNum }}</span>
							</mat-option>
						</mat-autocomplete>
					</mat-form-field> -->
					<mat-radio-group class="flex gap" style="padding: 10px 0" color="primary" formControlName="listType">
						<mat-radio-button #main value="serials">סריאלי</mat-radio-button>
						<mat-radio-button value="products">מק"ט</mat-radio-button>
					</mat-radio-group>
					<mat-form-field *ngIf="form.controls.listType.value === 'serials'">
						<mat-label>סריאלי</mat-label>
						<input type="text" matInput [matAutocomplete]="autoSerials" formControlName="serialNumber" />
						<mat-autocomplete autoActiveFirstOption #autoSerials="matAutocomplete" [displayWith]="displayFnSerials">
							<mat-option *ngFor="let sn of serialNumbers$ | async" [value]="sn" style="direction: rtl">
								<span style="unicode-bidi: isolate">{{ sn.ProductId }}</span> /
								<span style="unicode-bidi: isolate">{{ sn.SerNum }}</span>
							</mat-option>
						</mat-autocomplete>
					</mat-form-field>
					<mat-form-field *ngIf="form.controls.listType.value === 'products'">
						<mat-label>מקט</mat-label>
						<input type="text" matInput [matAutocomplete]="autoProducts" formControlName="product" />
						<mat-autocomplete autoActiveFirstOption #autoProducts="matAutocomplete" [displayWith]="displayFnProducts">
							<mat-option *ngFor="let product of products$ | async" [value]="product" style="direction: rtl">
								<span style="unicode-bidi: isolate">{{ product.ProductId }}</span> /
								<span style="unicode-bidi: isolate">{{ product.Product_Name }}</span>
							</mat-option>
						</mat-autocomplete>
					</mat-form-field>
					<mat-form-field>
						<mat-label>הערה</mat-label>
						<textarea matInput formControlName="remark"></textarea>
						<mat-error>{{ getErrorMessage() }}</mat-error>
					</mat-form-field>
					<app-mobility-image-container
						(imageFinishedUploading)="addImageNameToUploadedImages($event)"
						[uploadImageToServerCallback]="uploadImageToServerCallback"
						[imagePrefix]="imagePrefix"
						[maxImages]="2"
					></app-mobility-image-container>
				</form>
			</div>
			<div mat-dialog-actions>
				<button mat-raised-button [mat-dialog-close]>חזור</button>
				<button mat-raised-button color="primary" (click)="onSubmit()">שלח</button>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
